import * as React from 'react';

import GenericRichText from '@lendi-jam/generic-rich-text';

import { GenericRichTextContent } from '#contentTypes/GenericRichText';

interface PrismicGenericRichTextProps {
  component: GenericRichTextContent;
}

const PrismicGenericRichText: React.FC<PrismicGenericRichTextProps> = ({ component }) => {
  const RichTextContent = component.primary;
  const content = RichTextContent.rich_text_content.html;
  return (
    <GenericRichText
      content={content}
      textAlign={RichTextContent.text_alignment}
      isFullWidth={component.primary.is_full_width}
    />
  );
};

export default PrismicGenericRichText;
